import { AuthEnums } from 'dashboard-services/api/auth';
import { ActionService } from 'dashboard-services/services';
import { DashboardLinkFactory } from 'ng-common-features/urlBuilder';
import { globalActions } from 'primary-components';

import { basicPipelineCreatorActions } from 'actions/modules/datascience';

export default (() => {
  const ON_CHANGE = 'ON_CHANGE_SHARE_DIALOG_CREATOR_DATA_SCIENCE'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const getShareAllGroupPromise = ({ shareGroupCall }) => (dispatch, getState) => {
    const { tasks } = getState().datascienceState.creatorState.builderState,
          { emails, shareGroupAccess } = getState().datascienceState.creatorState.shareDialogState
    const groups = new Set(basicPipelineCreatorActions.getAllGroups(tasks)?.map(g => g.name) || [])
    const promises = []
    Array.from(groups)
      .filter(group => group)
      .forEach(group => 
        emails.forEach(email => (
          promises.push(
            shareGroupCall({ sharesList: [{
                email,
                access: shareGroupAccess || "RWS",
                sendMessage: false,
                groupName: group,
                merge: true
              }] })
              .catch(() => ({
                isError: true,
                groupName: group
              }))
          )
        ))
      )
    return promises;
  }

  const onSubmit = ({ sharePipelineCall, shareGroupCall }) => (dispatch, getState) => {
    const creatorState = getState().datascienceState.creatorState,
          selectedPipelineState = getState().datascienceState.listState.pipelinesState.basicState.selectedPipeline,
          { message, emails, isShareGroups } = creatorState.shareDialogState,
          id = creatorState.basicState.id,
          pipelineUrl = selectedPipelineState ? DashboardLinkFactory.dataScience.pipeline({ groupName: selectedPipelineState.groupName, pipelineName: selectedPipelineState.name, version: selectedPipelineState.version }) : undefined

    /*
      IMPORTANT:
      This call may not work if running on localhost - because of AWS WAF rule: EC2MetaDataSSRF_BODY.
      In request body there can't be any "http://localhost" which is used in url parameter = window.location.href when calling from localhost.
    */

    let promises = []
    const sharePipelinePromise = 
      sharePipelineCall({
        pipelineId: selectedPipelineState ? selectedPipelineState.id : id,
        url: selectedPipelineState ? pipelineUrl : window.location.href,
        access: AuthEnums.ACCESS_TYPE.R,
        message,
        emails
      })
    promises.push(sharePipelinePromise)

    if(isShareGroups) {
      const shareGroupPromises = dispatch(getShareAllGroupPromise({ shareGroupCall }))
      promises = promises.concat(shareGroupPromises)
    }
    Promise.all(promises)
      .then(responses => {
        const groupsNotShared = responses.filter(r => r?.isError).map(r => r?.groupName)
        if(groupsNotShared.length > 0) {
          dispatch(globalActions.getToastsStore()).error(
            "Some groups could not be shared. User may lack permissions. \n Groups: " + groupsNotShared.toUnique().join(", ") + ".",
            "Pipeline not fully shared",
            {
              withCancel: true
            }
          );
        }
        dispatch(onChange(false, "isOpen"))
        dispatch(globalActions.getMessageStore()).success("You succesfully shared pipeline.")
      })
  }

  const SET_ERRORS = 'SET_ERRORS_SHARE_DIALOG_CREATOR_DATA_SCIENCE'
  const setErrors = ActionService.makeActionCreator(SET_ERRORS, 'errors')

  const CLEAN_ALL = 'CLEAN_ALL_SHARE_DIALOG_DATA_SCIENCE'
  const cleanAll = ActionService.makeActionCreator(CLEAN_ALL)

  return {
    cleanAll,
    CLEAN_ALL,
    onChange,
    ON_CHANGE,
    onSubmit,
    SET_ERRORS,
    setErrors
  }
})()
